// 引入axios以及element ui中的loading和message组件

import router from './../../router/router';

import Sto from 'store';

import Config from '../../config/index';

import axios from 'axios'

import {
	Loading,
	Message
} from 'element-ui'

const baseUrl = Config.target

const instance = axios.create()

instance.defaults.baseURL = Config.target;

instance.defaults.timeout = 90000

// instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http请求拦截器
instance.interceptors.request.use(config => {

	// element ui Loading方法
	let cookies = Sto.get(Config.constant.cookie);
	cookies = cookies ? cookies : {}
	// 
	let tokenTime = cookies && cookies.hasOwnProperty('tokenTime') ? cookies.tokenTime : '';

	// 不能进行超时验证的api接口
	let url = ['/admin/login', '/get/token']

	// 如果请求的路由不是登录也不是更新token，就对登录进行验证，如果tokentime过期了就跳转到登录页
	// if( url.indexOf(config.url) == -1 && (!tokenTime || (new Date()).getTime() - tokenTime >= 7200000)){
	// 	delete cookies.tokenTime;
	// 	Sto.set(Config.constant.cookie, cookies)
	// 	Message.error({
	// 		message: '登录超时'
	// 	})

	// 	router.push({path: Config.route.login})

	// 	return Promise.reject(new Error('过期验证'))
	// }
	return config
}, error => {
	Message.error({
		message: '加载超时'
	})
	return Promise.reject(error)
})

// http响应拦截器
// instance.interceptors.response.use(data => { // 响应成功关闭loading
// 	// loadinginstace.close()
// 	return data
// }, error => {
// 	// loadinginstace.close()
// 	Message.error({
// 		message: '加载失败！'
// 	})
// 	router.push({
// 		path: Config.route.error500
// 	})
// 	return Promise.reject(error)
// })

export default instance



// WEBPACK FOOTER //
// ./src/api/fetch/filterHttp.js